<div [ngClass]="{'padding-fixed': fixed}">
    <app-section-one-scotia [brand]="brand"></app-section-one-scotia>
    <app-section-two-scotia [brand]="brand"></app-section-two-scotia>
    <app-section-three-scotia [brand]="brand"></app-section-three-scotia>
    <app-section-four-scotia [brand]="brand"></app-section-four-scotia>
    <app-footer-landing-scotia [brand]="brand" class="landing-footer"></app-footer-landing-scotia>
</div>